/*
 * Copyright (c)  CYBERKOALA LLC 2026.
 * Proprietary License.
 * Redistribution and use in source and binary forms, with or without
 * modification, are restricted.
 */

import { create } from 'zustand';

type CallUIState = {
  raisedHand: boolean;
  setRaisedHand: (value: boolean) => void;
};

export const useCallUIStore = create<CallUIState>((set) => ({
  raisedHand: false,
  setRaisedHand: (value) => set({ raisedHand: value }),
}));